import React, {useEffect, useState} from 'react';
import {useAI} from "../hooks/useAI";
import {ChatBubble} from "./ChatBubble";
import {useError} from "../hooks/useError";
import {createAIMessage} from "../services/CourseRepository";
import {AIResponse} from "./AIResponse";
import {RiRobot3Line} from "react-icons/ri";
import classNames from "classnames";
import {IoIosSend} from "react-icons/io";
import {MdCurrencyExchange} from "react-icons/md";

export function AIPanel({show, initCoins}) {

    const {messages, addMessage} = useAI();
    const {setErrorMessage, errorMessage} = useError();
    const [chatMessage, setChatMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [coins, setCoins] = useState(initCoins ?? 0)

    const spinnerClass = classNames("d-flex justify-content-center align-items-center rounded-5 p-3 ", {
        "d-none": !loading
    })

    useEffect(() => {
        setLoading(true)
        if(messages.length > 0) {
            const lastMessage = messages[messages.length-1];
            if(lastMessage.type !== "SYSTEM") {

                createAIMessage(lastMessage, setErrorMessage).then(response => {
                    addMessage({
                        content: response.message,
                        type: "SYSTEM",
                        contentType:"MESSAGE"
                    })
                    setLoading(false);
                    setCoins(response.coins)

                    if(errorMessage != null && errorMessage !== "") {
                        setErrorMessage("")
                    }
                }).catch(e => {
                    setLoading(false)
                    setErrorMessage(e.response.data.message)
                })
            }
            setLoading(false)
        }

    }, [messages]);

    function createAIMsg() {
        addMessage({type:"USER", content:chatMessage, contentType:"SAMTALE"})
        setChatMessage("");
        setLoading(true)
    }

    function inputKeyHandle(event) {
        if(event.key === "Enter") {
            createAIMsg()
        }

    }

    return (
        <div className={"p-0  sticky-top"} style={{minHeight: "85vh", height: "85vh", overflowX:"clip", zIndex:10}} >

            {
                messages.length === 0 ?
                    <div
                        className={"d-flex flex-column align-items-center justify-content-center text-center mt-3 h-100"}>
                        <RiRobot3Line size={84} className={"border rounded-5 p-3 mb-2 bg-dark text-white  "}/>
                        <p><strong>Hva lurer du på?</strong></p>
                    </div>
                    :
                    <div className={"d-flex p-5 flex-column align-content-end "}
                         style={{minHeight: "100%", height: "100%", overflowX:"hidden !important", overflowY:"scroll"}}>
                        {
                            messages.map(message => (
                                <>
                                    {
                                        message.type === "SYSTEM" ?

                                            <AIResponse message={message}/>
                                            :
                                            <ChatBubble message={message}/>
                                    }
                                </>
                            ))
                        }
                        <div className={spinnerClass}>
                            <RiRobot3Line size={24} className={" me-2 text-dark"}/>
                            <h5 className={"m-0 p-0 fw-bold me-2"}>Kjemi-BOT</h5>
                            <div className={"spinner-grow text-bg-dark"} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div className={"badge bg-danger text-white mt-3 p-3 " +(errorMessage != null && errorMessage !== "" ? "" : "d-none")}>
                            <p className={"m-0 p-0"}>{errorMessage}</p>
                        </div>
                    </div>

            }



            <div className={"px-5 row pt-2 border-top"} >
                <div className={"col-2 d-flex align-items-center"}>
                    <MdCurrencyExchange className={"me-2"} size={16}/>
                    <label className={"fw-bold"}>{coins}</label>
                </div>
                <input type={"text"} className={"form-control col "}  placeholder={"Spør om hva som helst"}
                       value={chatMessage} onChange={e => setChatMessage(e.target.value)}
                       onKeyDown={(e) => inputKeyHandle(e)}/>
                <button className={"btn btn-primary text-white ms-2 col-2"} onClick={() => createAIMsg()}>
                    <IoIosSend size={24}/>
                    <label>Send</label>
                </button>
            </div>
        </div>
    );


}